export const MAINTENANCE_REDIRECT_STORAGE_KEY = 'helix:maintenance-redirect';

export function isMaintenancePath(path: string): boolean {
  const pathname = path.split('?')[0];
  return pathname === '/maintenance' || pathname.endsWith('/maintenance');
}

export function isValidMaintenanceRedirect(path: string): boolean {
  if (!path || isMaintenancePath(path)) {
    return false;
  }

  const pathname = path.split('?')[0];
  // Root is never a meaningful post-maintenance destination.
  return pathname !== '/' && pathname !== '';
}

export function getQueryRedirect(queryRedirect: unknown): string | undefined {
  if (typeof queryRedirect === 'string' && isValidMaintenanceRedirect(queryRedirect)) {
    return queryRedirect;
  }

  if (Array.isArray(queryRedirect) && typeof queryRedirect[0] === 'string') {
    return getQueryRedirect(queryRedirect[0]);
  }

  return undefined;
}

export function saveMaintenanceRedirect(path: string): void {
  if (!isValidMaintenanceRedirect(path)) {
    return;
  }

  try {
    sessionStorage.setItem(MAINTENANCE_REDIRECT_STORAGE_KEY, path);
  } catch {
    // sessionStorage may be unavailable (private browsing, SSR).
  }
}

export function getMaintenanceRedirect(): string | undefined {
  try {
    const stored = sessionStorage.getItem(MAINTENANCE_REDIRECT_STORAGE_KEY);
    return stored && isValidMaintenanceRedirect(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
}

export function clearMaintenanceRedirect(): void {
  try {
    sessionStorage.removeItem(MAINTENANCE_REDIRECT_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Resolves the post-maintenance destination from the route query or sessionStorage.
 * sessionStorage is only used when the query param is missing (e.g. after reload).
 */
export function resolveMaintenanceRedirect(queryRedirect: unknown): string | undefined {
  const fromQuery = getQueryRedirect(queryRedirect);
  if (fromQuery) {
    return fromQuery;
  }

  return getMaintenanceRedirect();
}
